import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import FungalConquest from './components/FungalConquest';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FungalConquest />
  </React.StrictMode>
);
